import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { IRateCardInclusivityType } from '../interfaces/ratecard-inclusivity-type';

@Injectable({ providedIn: 'root' })
export class AgreementService extends BaseDataService {
  public url = '/api/agreement';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public getByType(typeId?: number, orgId?: number, deptId?: number): Promise<any> {
    return this.http
      .get<any>(
        `${this.url}/${typeId == null ? 0 : typeId}/${orgId == null ? 0 : orgId}/${
          !deptId ? 0 : deptId
        }`,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public isCustomerAbleToCancelOrder(orgId: number, taskId: number): Promise<boolean> {
    const isCustomerAbleToCancelDTO = {
      orgId,
      taskId,
    };
    const myObject = JSON.parse(JSON.stringify(isCustomerAbleToCancelDTO));
    const params = new HttpParams({ fromObject: myObject });
    return this.handleRequest<boolean>(
      this.http.get<boolean>(`${this.url}/isCustomerAbleToCancelOrder`, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  public agreementAgreed(): Promise<boolean> {
    return this.http
      .get<boolean>(`${this.url}/agreementAgreed`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  save(data: any): Promise<any> {
    return this.http.post<any>(`${this.url}/save`, data).toPromise().catch(this.handleError);
  }

  delete(id) {
    return this.http
      .delete(`${this.url}/delete-agreement/${id}`)
      .toPromise()
      .catch(this.handleError);
  }

  public extractData(res: any) {
    return res;
  }

  public handleError(errorResponse: HttpErrorResponse | any) {
    let fullErrorMessage: string;
    if (errorResponse instanceof HttpErrorResponse) {
      const error = errorResponse.error || JSON.stringify(errorResponse);
      fullErrorMessage = `${errorResponse.status} - ${errorResponse.statusText || ''} ${error}`;
    } else {
      fullErrorMessage = errorResponse.message ? errorResponse.message : errorResponse.toString();
    }
    console.error(fullErrorMessage);
    return Promise.reject(fullErrorMessage);
  }

  public getInclusivityTypes(): Promise<IRateCardInclusivityType[]> {
    return this.http.get<IRateCardInclusivityType[]>(`${this.url}/inclusivityTypes`).toPromise();
  }
}
